const store = new Vuex.Store({
    state: {
        keyword: '',
        hits:[],
        products: [],
        brands: [],
        cats: [],
    },

    mutations: {
        updateKeyword (state, payload) {
            state.keyword = payload
        },
        updateHits (state, payload) {
            state.hits = payload
        },
        updateProducts (state, payload) {
            state.products = payload
        },
        updateBrands (state, payload) {
            state.brands = payload
        },
        updateCategories (state, payload) {
            state.cats = payload
        },
    }
})

var searchMixin = {
    store,
    data: function () {
        return {
            keyword: '',
        }
    },

    created: function () {
        if(this.$route.query['keyword']) {
            this.keyword = this.$route.query['keyword']
            store.commit('updateKeyword', this.keyword)
        } else
            store.commit('updateKeyword', '')
    },

    methods: {
        search: function(e) {
            let keyword = ''

            // use mousedown to take precedence over blur
            if (e.type == 'mousedown') {
                keyword = e.currentTarget.getAttribute('data_value')
            } else if (e.type == 'keyup') {
                keyword = e.target.value
            }

            this.$root.recordAndroidAnalytics('MPL Search', { 'Input': keyword }, ['moengage'])
            this.$root.recordAndroidAnalytics('MPL_Search', { method: keyword }, ['sas360'])

            if(this.$route.name == 'search_results') {
            // use this.$router.push and force reload if you want to keep history
                // this.$router.push({
                this.$router.replace({ query: { keyword: keyword } })
                // this.$router.go()
            } else {
                this.$router.push({
                    name: 'search_results',
                    query: { keyword: keyword }
                })
            }
        },

        listing: function(e) {
            let id = e.currentTarget.getAttribute('data_id')
            let type = e.currentTarget.getAttribute('data_type')
            let name = e.currentTarget.getAttribute('data_name')

            this.$root.recordAndroidAnalytics('MPL Search', { 'Input': name }, ['moengage'])
            this.$root.recordAndroidAnalytics('MPL_Search', { method: name }, ['sas360'])

            this.$router.push({
                name: 'listing',
                query: { type: type, selected: id, name: name }
            })
        },

        clearDropdown() {
            store.commit('updateProducts', [])
            store.commit('updateBrands', [])
            store.commit('updateCategories', [])
        },

        clearSuggestions: function(e) {
            this.clearDropdown()
            store.commit("updateKeyword", '')
            this.$root.hideOverlay()
        },

        showSuggestions: function(e) {
            if(!this.$root.isOverlayed)
                this.$root.showOverlay()

            this.debounceAutocomplete(e)
        },

        debounceAutocomplete: _.debounce(function (e) {
            if(e.target.value.length > 2 && e.key != 'Enter') {
                let hits = []
                let products = []
                let brands = []
                let cats = []
                let filterKey = e.target.value

                axios
                    .get("/search", {
						params: {
                            term: filterKey,
                        },
					})
                    .then(response => {
                        hits = response.data['hits']

                        if (response.data['dropdownProducts'].length) {
                            products = response.data['dropdownProducts']
                        }

                        if (response.data['dropdownBrands'].length) {
                            brands = response.data['dropdownBrands']
                        }

                        if (response.data['dropdownCategories'].length) {
                            cats = response.data['dropdownCategories']
                        }

                        store.commit('updateHits', hits)
                        store.commit('updateProducts', products)
                        store.commit('updateBrands', brands)
                        store.commit('updateCategories', cats)
                    })

            } else {
                // hide suggestions
                this.clearDropdown()
            }
        }, 400),
    }
}

export default searchMixin
